<template>
  <div
    class="video-panorama"
    :class="{ hide: ended }"
  >
    <div
      v-if="notAvailable"
      class="not-available"
    >
      {{ $t("video360.notAvailable") }}
    </div>
    <youtube
      v-else-if="video.platform === 'youtube'"
      ref="youtube"
      width="100%"
      height="100%"
      :video-id="video.videoId"
      :player-vars="youtubePlayerVars"
      @ready="onYouTubeReady"
      @ended="onYouTubeEnd"
    />
    <vue-vimeo-player
      v-else-if="video.platform === 'vimeo'"
      ref="vimeo"
      :player-width="vimeoPlayerVars.playerWidth"
      :player-height="vimeoPlayerVars.playerHeight"
      :autoplay="true"
      :controls="true"
      :video-id="video.videoId"
      @ready="onVimeoReady"
      @ended="onEnd"
    />
    <iframe
      v-else
      :src="video.videoUrl"
      width="100%"
      height="100%"
      frameBorder="0"
    />
  </div>
</template>

<script>
import { Youtube } from 'vue-youtube'
import { vueVimeoPlayer } from 'vue-vimeo-player'

export default {
  name: 'VideoPanorama',
  components: {
    Youtube,
    vueVimeoPlayer
  },
  props: {
    video: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    notAvailable: false,
    ended: false,
    youtubePlayerVars: {
      autoplay: 1,
      rel: 0
    },
    vimeoPlayerVars: {
      playerHeight: window.innerHeight,
      playerWidth: window.innerWidth
    }
  }),
  computed: {},
  mounted () {
    this.initVideo()
  },
  methods: {
    initVideo () {
      const initiator = {
        youtube: this.initYouTube,
        vimeo: this.initVimeo
      }
      const platform = this.video.platform
      initiator[platform] && initiator[platform]()
    },
    initYouTube () {
      if (this.$isChina) {
        this.notAvailable = true
      }
    },
    initVimeo () {
      if (this.$isChina) {
        this.notAvailable = true
      }
    },
    onYouTubeReady () {
      if (this.$refs.youtube) {
        // Auto Mute
        this.$refs.youtube.player.mute()
      }
    },
    onVimeoReady () {
      this.$refs.vimeo.mute()
    },
    onYouTubeEnd () {
      this.onEnd()
    },
    onEnd () {
      this.ended = true
      this.$emit('end')
    }
  }
}
</script>

<style lang="stylus" scoped>
.video-panorama {
  width: 100vw;
  height: 100vh;
  position: relative;
  opacity: 1;
  z-index: 1;
  transition: opacity 0.5s;

  &.hide {
    opacity: 0;
  }

  > * {
    width: 100%;
    height: 100%;
  }
}

.not-available {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFF;
}
</style>
